import React, { useState, FC } from 'react'
import { ButtonBase } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'

import {
  DEFAULT_PER_PAGE_NEW_SRP,
  getValidSearchQuery,
  SearchFocusType,
} from '@src/utils/searchUtils'

import { useSearchContext } from '@src/routes/NewSearchResults/SearchContext'
import SearchResultsCount from '@src/routes/NewSearchResults/SearchResultsCount/SearchResultsCount'
import FilterAndSortIcon from '@src/icons/FilterAndSortIcon'

// import SearchResultsSortBar from '../SearchResultsSortBar/SearchResultsSortBar'
import MobileFilterAndFacetModal from '@src/routes/NewSearchResults/MobileFilterAndSortModal/MobileFilterAndFacetModal'
import { useSearchQuery } from '@src/pages/[country]/[language]/search/[searchTerm]'

const useStyles = makeStyles()((theme) => ({
  mobileMenu: {
    display: 'flex',
    flexDirection: 'column',
  },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
  },
  filterButton: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    alignItems: 'center',
  },
  filterIcon: {
    fontSize: theme.typography.pxToRem(24),
    marginRight: theme.spacing(2),
  },
  bottomRow: {
    display: 'flex',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400, // Tablet view
    [theme.breakpoints.down('sm')]: {
      fontWeight: 600, // Mobile view
    },
  },
  filterTextStyle: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
  },
}))

const MobileSearchResultsMenu: FC = () => {
  const { classes } = useStyles()
  const [query] = useSearchQuery()
  const { facets, isStructureSearch, metadata } = useSearchContext()
  const router = useRouter()
  const validSearchQuery = getValidSearchQuery({
    focus: router.query.focus,
    term: router.query.term,
  })
  const currPage = query.page ? Number(query.page) : 1
  const resultCount = metadata.count ?? metadata.itemCount ?? 0
  const perPage =
    router.query.focus === SearchFocusType.Products ||
    router.query.focus === SearchFocusType.B2B
      ? DEFAULT_PER_PAGE_NEW_SRP
      : metadata.perPage

  const [isFilterAndSortModalOpen, setIsFilterAndSortModalOpen] =
    useState(false)

  const handleOnModalClose = (): void => {
    setIsFilterAndSortModalOpen(false)
  }

  const handleFilterClick = (
    e:
      | React.MouseEvent<EventTarget & HTMLSpanElement>
      | React.KeyboardEvent<EventTarget & HTMLSpanElement>
  ): void => {
    e.preventDefault()
    setIsFilterAndSortModalOpen(true)
  }

  return (
    <div className={classes.mobileMenu} data-testid="mobile-srp-menu">
      <div className={classes.topRow} data-testid="srp-filter-and-sort">
        <ButtonBase
          className={classes.filterButton}
          onClick={handleFilterClick}
        >
          <FilterAndSortIcon
            className={classes.filterIcon}
            fontSize="inherit"
            color="primary"
          />
          <div className={classes.filterTextStyle}>
            <FormattedMessage id="FILTER" defaultMessage="Filter" />
          </div>
        </ButtonBase>
        {/* <SearchResultsSortBar /> */}
      </div>

      <div className={classes.bottomRow}>
        <SearchResultsCount
          currPage={currPage}
          perPage={perPage}
          resultCount={resultCount}
          searchTerm={validSearchQuery.term}
          searchType={validSearchQuery.focus}
        />
      </div>

      <MobileFilterAndFacetModal
        facets={facets}
        isStructureSearch={isStructureSearch}
        isModalOpen={isFilterAndSortModalOpen}
        onModalClose={() => handleOnModalClose()}
        showSortBar
      />
    </div>
  )
}

export default MobileSearchResultsMenu
